import { h } from 'preact';

const Download = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M8 0a.5.5 0 0 1 .5.5v8.793l1.646-1.647a.502.502 0 0 1 .708.708l-2.5 2.5a.502.502 0 0 1-.708 0l-2.5-2.5a.502.502 0 0 1 .708-.708L7.5 9.293V.5A.501.501 0 0 1 8 0z"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 11a.5.5 0 0 1 .5.5v3c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5l.001-3a.5.5 0 0 1 1 0v3a.5.5 0 0 0 .499.5h9c.275 0 .5-.225.5-.5v-3a.5.5 0 0 1 .5-.5z"/>
		</svg>
	);
};

export default Download;
